export default "__VITE_ASSET__70ae3d59__"